import { styled } from '@mui/material';

export const App = styled('div')(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  minHeight: '100%',
  paddingTop: '40px',
  margin: '0 auto',

  [theme.breakpoints.down('2xl')]: {
    paddingTop: '20px',
  },
  [theme.breakpoints.down('sm')]: {
    paddingTop: '16px',
  },
}));

export const Main = styled('main')(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  gap: '170px',
  flex: '1 1 auto',
  width: '100%',
  maxWidth: '1812px',
  padding: '40px 40px 0',
  overflow: 'hidden',

  [theme.breakpoints.down('2xl')]: {
    gap: '140px',
    maxWidth: '1388px',
    padding: '20px 30px 0',
  },
  [theme.breakpoints.down('xl')]: {
    gap: '112px',
  },
  [theme.breakpoints.down('lg')]: {
    gap: '96px',
  },
  [theme.breakpoints.down('md')]: {
    gap: '72px',
    padding: '20px 20px 0',
  },
  [theme.breakpoints.down('sm')]: {
    gap: '64px',
    padding: '16px 16px 0',
  },
}));
